$(function searchAndHandleInteractiveSection() {
    $.each($('.interactive-section'), (_index, anchor) => {
        handleInteractiveSection(anchor);
    });
});

function handleInteractiveSection(anchor) {
    const section = $(anchor);
    const tabsWrapper = section.find('.tabs-wrapper');
    const numberOfTabs = section.find('li').length;
    tabsWrapper.append(`<nav class="slider-nav"></nav>`);

    const sliderNav = section.find('.slider-nav');

    section.find('li').map(index => {
        if (index === 0) {
            sliderNav.append(`<a class='active'></a>`);
        } else {
            sliderNav.append(`<a></a>`);
        }
    });

    sliderNav.prepend('<img src="/static/img/sliderArrow.svg" class="prev-arrow" alt="prev-arrow">');
    sliderNav.append('<img src="/static/img/sliderArrow.svg" class="next-arrow" alt="next-arrow">');

    const nextArrow = $('.slider-nav').find('.next-arrow');
    const prevArrow = $('.slider-nav').find('.prev-arrow');

    let mainIndex = 0;
    let prevIndex = 0;

    nextArrow.click(function() {
        if (mainIndex < numberOfTabs - 1) {
            prevIndex = mainIndex;
            mainIndex++;

            changeTab(section, mainIndex, prevIndex);
        }
    });

    prevArrow.click(function() {
        if (mainIndex > 0) {
            prevIndex = mainIndex;
            mainIndex--;

            changeTab(section, mainIndex, prevIndex);
        }
    });

    section.find('a').click(function() {
        const selectedIndex = $(this).index() - 1;
        prevIndex = mainIndex;
        mainIndex = selectedIndex;

        changeTab(section, mainIndex, prevIndex);
    });

    section.find('li').click(function() {
        const selectedIndex = $(this).index();
        prevIndex = mainIndex;
        mainIndex = selectedIndex;

        changeTab(section, mainIndex, prevIndex);
    });
}

function changeTab(section, index, prevIndex) {
    if (index === prevIndex) {
        return;
    }

    animateTabChange(section, index, prevIndex);

    $.each(section.find('li'), (tabIndex, anchor) => {
        $(anchor).removeClass('active');
        if (index === tabIndex) {
            $(anchor).addClass('active');
        }
    });

    $.each(section.find('a'), (tabIndex, anchor) => {
        $(anchor).removeClass('active');
        if (index === tabIndex) {
            $(anchor).addClass('active');
        }
    });
}

function animateTabChange(section, index, prevIndex) {
    const $newSlide = section.find(`.img-wrapper img:eq(${index})`);
    const $prevSlide = section.find(`.img-wrapper img:eq(${prevIndex})`);

    $prevSlide.animate(
        {
            opacity: 0,
        },
        200,
        () => {
            $prevSlide.removeClass('active');

            $newSlide.addClass('active').animate(
                {
                    opacity: 1,
                },
                200,
            );
        },
    );
}



// WEBPACK FOOTER //
// ./js/interactive-section.js